import { VerificationService } from '@sheerid/jslib';
import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import { getSuccessRedirect } from '../../lib/StepComponentHelpers';
import { redirect } from '../../lib/utils/browser';

interface StepSuccessProps {
    verificationService: VerificationService;
}

const StepSuccess = ({ verificationService }: StepSuccessProps) => {
    const redirectDestination = getSuccessRedirect(verificationService);

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-header__title sid-l-horz-center sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Success! You've been verified." />
                </div>
                <div className="sid-header__subtitle sid-l-horz-center">
                    <FormattedHTMLMessage
                        id="step.success.subtitle"
                        defaultMessage={
                            `Here is your personal coupon code.
                        It is unique to you and can only be used once.`
                        }
                    />
                </div>
            </div>

            <div className="sid-submit sid-l-space-top-md">
                <button
                    type="button"
                    onClick={() => redirect(redirectDestination)}
                    className="sid-btn sid-btn--dark"
                >
                    <FormattedHTMLMessage id="step.success.redirectButtonText" defaultMessage="Use code now" />
                </button>
            </div>

            <div className="sid-footer sid-l-horz-center sid-l-space-top-lg sid-h-small-text">
                <FormattedHTMLMessage
                    id="step.success.verificationOnly"
                    defaultMessage={`
                        SheerID handles verification only.
                        Now that you've been approved, please direct all questions about the
                        promotion terms and/or code use to {companyName} customer service.
                    `}
                />
            </div>
        </div>
    );
};


export const StepSuccessComponent = StepSuccess;
